<template>
    <v-container>
        <v-row dense>
            <v-col cols="12" md="6">
                <v-combobox 
                    v-model="selected_kols" 
                    :items="accessableKols"
                    label="筛选达人"
                    multiple
                    chips
                ></v-combobox>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field label="开始日期" type="date" v-model="date_start"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field label="结束日期" type="date" v-model="date_end"></v-text-field>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="3">
                <v-select v-model="searchMethod" :items="searchMethods" label="搜索方式"></v-select>
            </v-col>

            <!-- Dynamic Input Field -->
            <v-col cols="12" md="8">
                <component :is="currentComponent" v-model="searchInput" :label="currentLabel"></component>
            </v-col>

            <v-col cols="12" md="1">
                <v-btn icon @click="triggerSearch">
                    <v-icon>mdi-magnify</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="loading">
            <v-col cols="12">
                <v-text-field>加载中...</v-text-field>
                <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-col>
        </v-row>
        <v-row v-if="!loading">
            <template v-if="searchMethod === '商品'">
                <!-- <VDataTable :items="commodity_details" /> -->
                <CommodityExplainListResult :commodity_details="commodity_details" />
            </template>
            <template v-if="searchMethod === '讲解商品（采样）'">
                <SampledCommodityExplainListResult :commodity_details="sampled_commodity_details" />
            </template>
            <template v-if="searchMethod === '商品讲解（完整）'">
                <OutterCommodityExpalainListResult :commodity_details="commodity_details" />
            </template>
            <template v-else-if="searchMethod === '直播话术'">
                <VideoResult :videos="videos" />
            </template>
        </v-row>


    </v-container>




</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { get_accessable_kol_list, get_clip_material_list, query_commodity_explain_records, query_sampled_commodity_explain_records, query_outter_commodity_explanation } from '@/services/api.js'

//把VideoResult.vue这个组件引用到这里
import VideoResult from './result_show/VideoSearchResult.vue'
import CommodityExplainListResult from './result_show/CommodityExplainListResult.vue'
import SampledCommodityExplainListResult from './result_show/SampledCommodityExplainListResult.vue'
import OutterCommodityExpalainListResult from './result_show/OutterCommodityExpalainListResult.vue'

// const date_start = ref(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10));
// const date_end = ref(new Date().toISOString().substr(0, 10));  
const date_start = ref('');
const date_end = ref(new Date().toISOString().slice(0, 10));

const searchMethods = ref([
    '商品讲解（完整）',
    '讲解商品（采样）',
    '商品',
    '直播话术',
    '表情',
    '按图搜索'
]);


const items = [
    {
      name: 'African Elephant',
      species: 'Loxodonta africana',
      diet: 'Herbivore',
      habitat: 'Savanna, Forests',
    },
    // ... more items
  ]


// Determine the current component based on search method
const currentComponent = computed(() => {
    switch (searchMethod.value) {
        case '商品':
        case '讲解商品（采样）':
        case '商品讲解（完整）':
        case '直播话术':
            return 'v-text-field';
        case '表情':
            return 'v-text-field';
        case '按图搜索':
            return 'v-file-input';
        default:
            return 'v-text-field';
    }
});

// Determine the current label based on search method
const currentLabel = computed(() => {
    switch (searchMethod.value) {
        case '商品':
        case '讲解商品（采样）':
        case '商品讲解（完整）':
        case '直播话术':
            return '搜索内容';
        case '表情':
            return '表情';
        case '按图搜索':
            return '上传图片';
        default:
            return '搜索内容';
    }
});

import { useRouter } from 'vue-router'
const router = useRouter()
const talentParam = ref(router.currentRoute.value.query.talent ? router.currentRoute.value.query.talent.split(',') : null)  // 从url中获取的talent参数
const searchMethod = ref(router.currentRoute.value.query.searchMethod ? router.currentRoute.value.query.searchMethod : searchMethods.value[0])  // 从url中获取的searchMethod参数
const searchInput = ref(router.currentRoute.value.query.searchInput ? router.currentRoute.value.query.searchInput : '')  // 从url中获取的searchInput参数

const accessableKols = ref([]); // Define the accessableKols variable
const selected_kols = ref(null)

get_accessable_kol_list()
    .then(response => {
        // 转换response.data到combobox需要的格式
        const kolMap = new Map();

        response.forEach(kol => {
            const kolItem = {
                value: kol.id,
                title: kol.name
            };
            accessableKols.value.push(kolItem);
            kolMap.set(kol.id, kolItem);
        });

        // 根据talentParam初始化selected_kols
        if (talentParam.value && talentParam.value.length) {
            selected_kols.value = talentParam.value
                .map(talentId => kolMap.get(talentId))
                .filter(kolItem => kolItem != null); // 过滤掉未找到的项
        } else {
            sessionStorage.getItem('selectedKols') ? selected_kols.value = JSON.parse(sessionStorage.getItem('selectedKols')) : null
        }

        triggerSearch();
    })

const loading = ref(false);
const videos = ref([]); // Define the videos variable
const commodity_details = ref([]); // Define the commodity_details variable
const sampled_commodity_details = ref([]); // Define the sampled_commodity_details variable

const parseMaybeJson = (value) => {
    if (value == null) return [];
    if (typeof value === 'string') {
        try {
            return JSON.parse(value);
        } catch (error) {
            console.error('解析数据失败:', error, value);
            return [];
        }
    }
    return value;
}


const triggerSearch = () => {
    if (loading.value) 
    return; // 如果正在加载，就不再加载

    loading.value = true;
    // 调用后端接口，获取数据
    // 把数据传给组件
    console.log('selected_kols.value', selected_kols.value)
    var kol_list = selected_kols.value ? selected_kols.value.map(kol => kol.value) : [];

    if (kol_list.length === 0) {
        kol_list = null;
    }

    if (kol_list) {
        kol_list = kol_list.join(',');
    }
    console.log('kol_list', kol_list)

    sessionStorage.setItem('selectedKols', JSON.stringify(selected_kols.value))


    if (searchMethod.value === '直播话术') {
        get_clip_material_list({
            kol_list: kol_list,
            key_word: searchInput.value,
        }).then(response => {
            videos.value = response;
        })
        .finally(() => {
            loading.value = false; // Set loading to false
        });
    } else if (searchMethod.value === '商品') {
        // 打印参数
        query_commodity_explain_records({
            kol_list: kol_list,
            key_word: searchInput.value,
            start_date: date_start.value,
            end_date: date_end.value,            
        }).then(response => {
            commodity_details.value = parseMaybeJson(response);

            //打印出来
            console.log('commodity_details', commodity_details.value)
        })
        .finally(() => {
            loading.value = false; // Set loading to false
        });
    } else if (searchMethod.value === '讲解商品（采样）') {
        query_sampled_commodity_explain_records({
            kol_list: kol_list,
            key_word: searchInput.value,
            start_date: date_start.value,
            end_date: date_end.value,            
        }).then(response => {
            sampled_commodity_details.value = parseMaybeJson(response);

            //打印出来
            console.log('sampled_commodity_details', sampled_commodity_details.value)
        })
        .finally(() => {
            loading.value = false; // Set loading to false
        });
    } else if (searchMethod.value === '商品讲解（完整）') {
        query_outter_commodity_explanation({
            kol_list: kol_list,
            key_word: searchInput.value,
            start_date: date_start.value,
            end_date: date_end.value,            
        }).then(response => {
            commodity_details.value = parseMaybeJson(response);

            //打印出来
            console.log('commodity_details', commodity_details.value)
        })
        .finally(() => {
            loading.value = false; // Set loading to false
        });
    }
    else {
        loading.value = false;
    }

};
</script>
<style></style>